var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:_vm.classes,attrs:{"to":_vm.to}},[_vm._t("default"),(_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.$dictionary.get(_vm.label))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }